import { TranslateService } from '@ngx-translate/core';

import { TranslationKeyMap } from '../../coaching-insight.i18n';
import {
    ColumnConfigItem,
    HeaderExtraContent,
    Icon,
} from '../models/coaching.global.model';
import { SortDirection } from '../models/sorting.model';

const textAlign = 'text-align';
const headersContent = 'headers-content';

export function getFrontlineColumnConfigItemsConfig(
    tls: TranslateService,
): ColumnConfigItem[] {
    return [
        new ColumnConfigItem({
            header: tls.instant(TranslationKeyMap._7443_TEAM),
            colstyle: {
                width: '20rem',
                'max-width': '20rem',
                'min-width': '12rem',
            },
            active: true,
            styles: {},
            class: [],
            headerContentClass: 'header-content-oa',
            cellstyles: {
                [textAlign]: 'left',
            },
        }),
        new ColumnConfigItem({
            header: tls.instant(TranslationKeyMap._9845_FRONT_LINE_OA),
            active: true,
            colstyle: { width: '5%' },
            styles: {
                width: '5%',
                'min-width': '6.5rem',
                'max-width': '6.5rem',
            },
            icon: [
                new Icon({
                    class: [
                        'chevron-up',
                        'chevron-down',
                        'unfold-more-horizontal',
                    ],
                    counter: SortDirection.DESC,
                    defaultState: SortDirection.DESC,
                    state: true,
                    action: 'sortTeamByScore',
                    prop: 'oaSort',
                    actionParams: {},
                }),
            ],
            class: [],
            headerContentClass: headersContent,
            cellstyles: {
                [textAlign]: 'center',
            },
        }),
        new ColumnConfigItem({
            header: tls.instant(TranslationKeyMap._7491_EXPECTED_OPPS_),
            active: true,
            colstyle: { width: '8%' },
            styles: {
                width: '8%',
                'min-width': '7.5rem',
                'max-width': '7.5rem',
            },
            icon: [
                new Icon({
                    class: [
                        'chevron-up',
                        'chevron-down',
                        'unfold-more-horizontal',
                    ],
                    counter: SortDirection.DEFAULT,
                    state: true,
                    action: 'sortTeamByExpected',
                    prop: 'expectedSort',
                    actionParams: {},
                }),
            ],
            class: [],
            headerContentClass: headersContent,
            cellstyles: {
                [textAlign]: 'center',
            },
        }),
        new ColumnConfigItem({
            header: tls.instant(
                TranslationKeyMap._7492_OPPORTUNITY_FUNDED_COACHING,
            ),
            active: true,
            colstyle: {
                width: '23%',
            },
            colclass: 'last-col',
            styles: {
                width: '23%',
                'max-width': '94rem',
            },
            class: ['funded-coaching-bar-container'],
            headerContentClass: 'headers-content',
            cellstyles: {
                [textAlign]: 'center',
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            left: {
                class: 'funded-coaching-legend',
                /* eslint-disable @typescript-eslint/restrict-template-expressions */
                content: `
                    <div class='funded-coaching-legend-coached'>
                        <span class="legend-square green"></span>
                        <span>${tls.instant(
                            TranslationKeyMap._7488_COACHED,
                        )}</span>
                    </div>
                    <div class='funded-coaching-legend-uncoached'>
                        <span class="legend-square red"></span>
                        <span>${tls.instant(
                            TranslationKeyMap._7489_UNCOACHED,
                        )}</span>
                    </div>
                `,
            } as HeaderExtraContent,
        }),
    ];
}
